import { Box, Grid, LinearProgress, TextField } from '@mui/material';
import { IPae } from '../../../services/api/action-plan/Pae';
import { useEffect, useState } from 'react';

interface GeneralPaeProps {
    smDown: boolean;
    value: IPae | undefined,
    onChange: (data: IPae) => void
    error: boolean;
}

export const GeneralPae = ({onChange, smDown, value, error}: GeneralPaeProps) => {

    const [data, setData] = useState<IPae>({
        data_emissao: '',
        empresa_executora: '',
        responsavel_tecnico: '',
        art: '',
        orgao_fiscalizador: '',
    });

    useEffect(() => {
        if (value) {
            const dataFormatada = value.data_emissao.split(' ')[0];
            value.data_emissao = dataFormatada;
        }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const newData = {
            ...data,
            [name]: value,
        };
        setData(newData);
        onChange(newData);
    };

    
    return(
        <Box flex={1}>
            <Grid container spacing={1}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Data de emmissão'
                        type='date'
                        name='data_emissao'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={value?.data_emissao}
                        required
                        error={error ?? data.data_emissao === '' ? true : false}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Empresa executora'
                        type='text'
                        name='empresa_executora'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={value?.empresa_executora}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Responsável técnico'
                        type='text'
                        name='responsavel_tecnico'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={value?.responsavel_tecnico}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='ART (número)'
                        type='text'
                        name='art'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={value?.art}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Órgão fiscalizador'
                        type='text'
                        name='orgao_fiscalizador'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={value?.orgao_fiscalizador}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};